<h2 mat-dialog-title>Delete User</h2>
<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="deleteUser()">Delete</button>
</mat-dialog-actions>
